import { BadgeCheck } from "lucide-react";

const testimonials = [
  {
    name: "Jason M.", loc: "Toronto, ON", initials: "JM",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&q=60",
    result: "Saved $1,900/yr in fees",
    quote: "I'd been with the wrong trading platform for 4 years. AI Central matched me in under a minute and the fee difference alone paid for a vacation.",
  },
  {
    name: "Amanda K.", loc: "Vancouver, BC", initials: "AK",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&q=60",
    result: "Matched in 45 seconds",
    quote: "As a complete beginner I had no idea where to start. The match came with a trading platform that has real human support — exactly what I needed.",
  },
  {
    name: "Patrick L.", loc: "Calgary, AB", initials: "PL",
    img: null,
    result: "96.8% fit score",
    quote: "As an accountant, I analyze numbers for a living. I compared the AI's recommendation against my own spreadsheet — it found a better option.",
  },
  {
    name: "Sophie R.", loc: "Montreal, QC", initials: "SR",
    img: "https://images.pexels.com/photos/10816007/pexels-photo-10816007.jpeg?w=100&q=60",
    result: "Switched platforms in 2 days",
    quote: "I thought switching trading platforms would take weeks of paperwork. The activation flow walked me through everything step by step.",
  },
  {
    name: "Derek T.", loc: "Ottawa, ON", initials: "DT",
    img: "https://images.pexels.com/photos/31869537/pexels-photo-31869537.jpeg?w=100&q=60",
    result: "Referred his golf group",
    quote: "I'm a retired engineer. The matching logic impressed me — it factored in things I hadn't even considered, like withdrawal speed.",
  },
  {
    name: "Natalie W.", loc: "Edmonton, AB", initials: "NW",
    img: null,
    result: "Trading within a week",
    quote: "I was nervous about picking a platform for options. My match had the exact tools I needed, and the onboarding call made everything clear.",
  },
];

export const Testimonials = () => (
  <section id="testimonials" className="px-4 sm:px-6 py-16 scroll-mt-28">
    <div className="max-w-6xl mx-auto">
      <div className="max-w-2xl">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-600">Testimonials</span>
        <h2 className="font-heading text-3xl md:text-4xl font-bold tracking-tight text-gray-900 mt-3">
          Real Traders. Real Matches.
        </h2>
        <p className="text-base md:text-lg text-gray-600 mt-4">
          Thousands of traders and investors have already found their best-fit trading platform through AI Central.
        </p>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {testimonials.map((t, i) => (
          <div
            key={i}
            data-testid={`testimonial-card-${i}`}
            className="bg-white border border-gray-200 rounded-2xl p-7 flex flex-col hover:shadow-md transition-shadow duration-200"
          >
            <div className="flex items-center gap-3">
              {t.img ? (
                <img src={t.img} alt={t.name} className="w-11 h-11 rounded-full object-cover" />
              ) : (
                <span className="w-11 h-11 rounded-full bg-blue-100 text-blue-700 font-bold text-sm flex items-center justify-center">{t.initials}</span>
              )}
              <div>
                <p className="font-bold text-gray-900 text-sm flex items-center gap-1">
                  {t.name}
                  <BadgeCheck className="w-4 h-4 text-blue-600" />
                </p>
                <p className="text-xs text-gray-500">{t.loc}</p>
              </div>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-gray-600 flex-1">"{t.quote}"</p>
            <span className="mt-5 inline-flex self-start text-xs font-bold text-emerald-700 bg-emerald-50 border border-emerald-200 px-3 py-1 rounded-full">
              {t.result}
            </span>
          </div>
        ))}
      </div>

      <p className="mt-10 text-center text-sm text-gray-500 font-medium">
        The average user finds their trading platform match within 60 seconds of completing their profile.
      </p>
    </div>
  </section>
);
